import React from "react";
import Cookies from "universal-cookie";
import PageTitle from "../components/PageTitle/PageTitle";
import { Button, TextField } from "@material-ui/core";
import getImpostazioni from "../services/getImpostazioni";
import addAnagraficheFatture from "../services/addAnagraficheFatture";
import addDataIva from "../services/addDataIva";
import addDataStipendi from "../services/addDataStipendi";
import addMetodiPagamento from "../services/addMetodiPagamento";
import ManageRowSettings from "../widgets/ManageRowSettings";
import SettingsTitle from "../widgets/SettingsTitle";
import Loading from "../components/Loading";
import updatePatrimonio from "../services/updatePatrimonio";

export default class Impostazioni extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      data_stipendi: undefined,
      data_iva: undefined,
      anagrafica_fatture: [],
      metodi_pagamento: [],
      errore_stipendi: false,
      errore_iva: false
    };

  }

  async reload() {
    this.setState({errore_iva: false, errore_stipendi: false})
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    let res = await getImpostazioni(username, token)
    res.forEach(element => {
      if (element['tipo'] === 'data_iva') {
        this.setState({ data_iva: element['payload'], ivaSet: true })
        return
      }
      if (element['tipo'] === 'data_stipendi') {
        this.setState({ data_stipendi: element['payload'], stipendiSet: true })
        return
      }
      if (element['tipo'] === 'anagrafiche' && element['payload'] !== '[]') {
        this.setState({ anagrafica_fatture: JSON.parse(element['payload']) });
      }
      if (element['tipo'] === 'pagamenti' && element['payload'] !== '[]') {
        this.setState({ metodi_pagamento: JSON.parse(element['payload']) });
      }
      if (element['tipo'] === 'patrimonio' && element['payload'] !== '') {
        
        var t = element['payload'].replace(/\./g, ',').replace(/\./g, '');
        if(/[^0-9,]+/.test(t)) {
            t = t.replace(/[^0-9]+/g, '');
        }
        var chunks = t.split(',');
        chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        t = chunks.join(',');
        
        this.setState({ patrimonio: t.trim() });
      }
    });
    this.setState({ loading: false })
  }

  async componentDidMount() {
    await this.reload();
  }

  addInput(param) {
    let obj = param === 'metodi_pagamento' ? { label: '' } : { label: '', color: '', scarico: '100' }
    let new_array = [...this.state[param], obj]
    this.setState({ [param]: new_array })
  }

  async updatePatrimonio() {
    if (!this.state.patrimonio) {
      this.setState({ errore_patrimonio: true })
      return
    }

    if (!window.confirm('Vuoi davvero aggiornare manualmente il patrimonio attuale? Questo avvierà il calcolo dell\'errore rispetto al valore calcolato automaticamente. Premi OK per proseguire, Annulla per cancellare.')) {
      return;
    }

    this.setState({ loading: true })
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });

    let res = await updatePatrimonio(username, token, this.state.patrimonio); 
    if (res.result === 'KO') {
      alert('Errore durante l\'aggiornamento del patrimonio. Per favore, riprova.');
      return;
    }

    this.reload()
  }

  async updateInfo() {
    
    if (this.state.data_iva < 1 || this.state.data_iva > 28 || !this.state.data_iva) {
      this.setState({ errore_iva: true })
      return
    }
    if (this.state.data_stipendi < 1 || this.state.data_stipendi > 28 || !this.state.data_stipendi){
      this.setState({ errore_stipendi: true })
      return
    }

    this.setState({ loading: true })
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    await addAnagraficheFatture(username, token, this.state.anagrafica_fatture)
    await addMetodiPagamento(username, token, this.state.metodi_pagamento)
    await addDataIva(username, token, this.state.data_iva)
    await addDataStipendi(username, token, this.state.data_stipendi)
    this.reload()
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    }

    return (
      <>
        <PageTitle title={'Impostazioni'} />
        <div style={dashboardView}>

          <div style={{ width: '50%', marginTop: 20, display: 'flex', flexDirection: 'column ', alignItems: 'flex-end' }}>
            <TextField
              id="stipendi"
              error={this.state.errore_stipendi}
              helperText={this.state.errore_stipendi ? "Inserisci una data valida" : ' '}
              onChange={e => this.setState({ data_stipendi: e.target.valueAsNumber })}
              inputProps={{ ...inputProps, readOnly: this.state.stipendiSet ? true : false }}
              variant="outlined"
              type="number"
              style={{ width: '80%' }}
              label="Giorno pagamento stipendi"
              value={this.state.data_stipendi}
              defaultValue={this.state.data_stipendi}
            />

            <TextField
              id="iva"
              helperText={this.state.errore_iva ? "Inserisci una data valida" : ' '}
              error={this.state.errore_iva}
              onChange={e => this.setState({ data_iva: e.target.valueAsNumber })}
              inputProps={{ ...inputProps, readOnly: this.state.ivaSet ? true : false }}
              variant="outlined"
              type="number"
              style={{ width: '80%', marginTop: 20 }}
              label="Giorno pagamento F24"
              value={this.state.data_iva}
              defaultValue={this.state.data_iva}
            />

            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button
                onClick={() => { this.updateInfo() }}
                style={{ marginTop: 20, alignSelf: 'flex-end' }}
                variant="contained"
                color="secondary">
                Aggiorna
              </Button>

              
            </div>
          </div>

          <div style={{ width: '50%' }}>
            {/* Fatture */}
            <div style={rowTitle}>
              <SettingsTitle title="Aggiungi tag fatture:" />
              <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInput('anagrafica_fatture')}/>
            </div>

            <div>
              {this.state.anagrafica_fatture.map((el, i) => {
                return (
                  <div style={groupInput} key={`fattura${i}`}>
                    <TextField
                      size="small"
                      variant="outlined"
                      type='text'
                      value={el.label}
                      style={inputStyle}
                      onChange={(e) => {
                        let arr = this.state.anagrafica_fatture
                        arr[i].label = e.target.value
                        this.setState({ anagrafica_fatture: arr })
                      }}
                    />
                    <TextField
                      size="small"
                      variant="outlined"
                      type='text'
                      placeholder="%IVA"
                      value={el.scarico}
                      style={smallInputStyle}
                      onChange={(e) => {
                        let arr = this.state.anagrafica_fatture
                        arr[i].scarico = e.target.value
                        this.setState({ anagrafica_fatture: arr })
                      }}
                    />
                    <TextField
                      size="small"
                      variant="outlined"
                      type='text'
                      placeholder="%TOT"
                      value={el.scaricoTot}
                      style={smallInputStyle}
                      onChange={(e) => {
                        let arr = this.state.anagrafica_fatture
                        arr[i].scaricoTot = e.target.value
                        this.setState({ anagrafica_fatture: arr })
                      }}
                    />
                    <ManageRowSettings
                      callback={() => {
                        let updated = this.state.anagrafica_fatture.filter((e, index) => index !== i)
                        this.setState({ anagrafica_fatture: updated })
                      }} />
                  </div>
                )
              })}
            </div>

            {/* Pagamenti */}
            <div style={rowTitle}>
              <SettingsTitle title="Aggiungi metodo di pagamento:" />
              <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInput('metodi_pagamento')}/>
            </div>

            <div>
              {this.state.metodi_pagamento.map((el, i) => {
                return (
                  <div style={groupInput} key={`pagamenti${i}`}>
                    <TextField
                      size="small"
                      variant="outlined"
                      type='text'
                      value={el.label}
                      style={inputStyle}
                      onChange={(e) => {
                        let arr = this.state.metodi_pagamento
                        arr[i].label = e.target.value
                        this.setState({ metodi_pagamento: arr })
                      }}
                    />
                    <ManageRowSettings
                      callback={() => {
                        let updated = this.state.metodi_pagamento.filter((e, index) => index !== i)
                        this.setState({ metodi_pagamento: updated })
                      }} />
                  </div>
                )
              })}
            </div>
          </div>

        </div>

        <div style={{ ...dashboardView, marginTop: 30, display: 'block' }}>

          <h2>Stato patrimoniale</h2> 

          <TextField
            id="patrimonio"
            helperText={this.state.errore_iva ? "Inserisci un valore valido" : ' '}
            error={this.state.errore_patrimonio}
            onChange={(e) => {
              var t = e.target.value.replace(/\./g, '');
              if(/[^0-9,]+/.test(t)) {
                  t = t.replace(/[^0-9]+/g, '');
              }
              var chunks = t.split(',');
              chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
              t = chunks.join(',');
              this.setState({ patrimonio: t.trim()});
            }}
            value={this.state.patrimonio}
            variant="outlined"
            type="text"
            style={{ width: '80%', marginTop: 10, marginRight: 20, alignSelf: 'flex-start' }}
            label="Stato patrimoniale attuale"
            defaultValue={this.state.patrimonio}
          />

          <Button
            onClick={() => { this.updatePatrimonio() }}
            style={{ marginTop: 20, alignSelf: 'flex-end' }}
            variant="contained"
            color="secondary">
            Aggiorna patrimonio
          </Button>

        </div>
      </>
    );
  }
}

const dashboardView = {
  backgroundColor: 'white',
  borderRadius: 10,
  padding: 30,
  marginRight: 10,
  width: '100%',
  boxShadow: '0px 2px 4px lightgrey',
  display: 'flex',
  flexDirection: 'row-reverse',
  justifyContent: 'center',
}

const dashboardViewRight = {
  backgroundColor: 'white',
  borderRadius: 10,
  padding: 30,
  marginLeft: 10,
  width: '100%',
  height: '100%',
  boxShadow: '0px 2px 4px lightgrey'
}

const inputProps = {
  inputMode: 'numeric',
  pattern: '[0-9]{2}',
  max: 28,
  min: 1
}

const rowTitle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: 4,
  borderBottom: '0.3px solid #c1c1c1',
  marginTop: 30,
  marginBottom: 20
}

const groupInput = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: 5
}

const inputStyle = {
  borderRadius: 4,
  width: '80%',
  paddingTop: 9,
  paddingBottom: 9,
  paddingInline: 9,
  outlineColor: '#4A4A4A',
  outlineWidth: "thin"
}

const smallInputStyle = {
  borderRadius: 4,
  width: '20%',
  marginLeft: 5,
  paddingTop: 9,
  paddingBottom: 9,
  paddingInline: 9,
  outlineColor: '#4A4A4A',
  outlineWidth: "thin"
}